import BaseService from '../../base';

class refunds extends BaseService {
  // 退票列表
  async refundsList(params) {
    return await this.get('/admin/order_refund', params);
  }
  // 导出退款记录
  async export(params) {
    return await this.get('/admin/order_refund/export_excel', params);
  }
  // 同意退款
  async refundConfirm(params) {
    return await this.post('/admin/order_refund/confirm', params);
  }
  async confirmRefund(params) {
    return await this.post('/api/v2/admin/orderRefund/confirm', params);
  }
  // 拒绝退款
  async refundReject(params) {
    return await this.post('/admin/order_refund/reject', params);
  }
}

export default new refunds();
